"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarIcon = void 0;
var react_1 = __importDefault(require("react"));
var style = {
    width: '1em',
    height: '1em',
    background: 'transparent',
    color: 'rgb(34,79,141)'
};
var CalendarIcon = function () {
    return react_1.default.createElement("svg", __assign({}, style, { focusable: "false", viewBox: "0 0 24 24", "aria-hidden": "true" }),
        react_1.default.createElement("path", { d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z" }),
        react_1.default.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }));
};
exports.CalendarIcon = CalendarIcon;
//# sourceMappingURL=CalendarIcon.js.map